'use strict';

import type { UserCallLog } from '../../Entities/User/UserCallLog';
import { EntityCollection } from '../EntityCollection';

export class UserCallLogCollection extends EntityCollection<UserCallLog> {}
